import React, { createContext, useContext } from 'react';

const SelectedIndex = createContext(undefined);

export const SelectedIndexProvider = ({ selectedIndex, children }) => {
  return <SelectedIndex.Provider value={{ selectedIndex }}>{children}</SelectedIndex.Provider>;
};

export function useSelectedIndex() {
  const context = useContext(SelectedIndex);
  if (!context) {
    throw new Error('useSelectedIndex must be called from a SelectedIndexProvider');
  }
  return context;
}
